import type { ButtonHTMLAttributes, FC, Ref } from 'react';

import cn from 'classnames';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  'aria-label': string;
  ref?: Ref<HTMLButtonElement>;
}

export const IconButton: FC<IconButtonProps> = ({ className, children, ref, ...props }) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        'inline-flex items-center justify-center size-8 rounded-full hover:bg-black/5 transition-colors',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
